export default "/packs/images/trash~d7e761c6c65c2083f10c8031e959d81b.svg";